(function() {
    'use strict';

    angular
        .module('ipmApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('qhp-workflow-landing-page', {
            parent: 'app',
            url: '/qhp-workflow',
            data: {
                authorities: ['ROLE_QHP'],
            },
            views: {
                'content@': {
                    templateUrl: 'app/qhp-workflow/landing-page.html',
                    controller: 'QHPLandingPageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('register');
                    $translatePartialLoader.addPart('carePlanReview');
                    $translatePartialLoader.addPart('qhpWorkflow');
                    return $translate.refresh();
                }],
                entity: ['QHPWorkflowService', function (QHPWorkflowService) {
                    return null;
                }],
            }
        });

    }

})();
